module.exports = __webpack_public_path__ + "img/china.7d9c9ae.png";